import React, { useEffect, useRef } from 'react';
import TranslationService from '../services/TranslationService';
const Translation = ({ item = null, asString = false, asHtml = false }) => {
    let translatedItems = [];
    if (!hasTranslationTags(item)) {
        translatedItems.push(translateKey(item, asString));
    }
    else {
        translatedItems.push(translateTags(item, asString));
    }
    if (asHtml) {
        return React.createElement("div", { dangerouslySetInnerHTML: { __html: translatedItems.join('') } });
    }
    else {
        return translatedItems;
    }
};
const translateKey = (item, asString) => {
    var _a, _b, _c;
    const value = (_a = TranslationService.get()[prepareTranslation(item)]) === null || _a === void 0 ? void 0 : _a.value;
    if (!value) {
        return item;
    }
    if (isLoggedIn() && !asString) {
        return renderTranslateLabelsHtml((_b = TranslationService.get()[prepareTranslation(item)]) === null || _b === void 0 ? void 0 : _b.value, item);
    }
    return (_c = TranslationService.get()[prepareTranslation(item)]) === null || _c === void 0 ? void 0 : _c.value;
};
const translateTags = (item, asString) => {
    let translations = [];
    item.replace(/t\((.*?)\)/g, function (match) {
        var _a, _b;
        const key = (_a = TranslationService.get()[prepareTranslation(match)]) === null || _a === void 0 ? void 0 : _a.key;
        const value = (_b = TranslationService.get()[prepareTranslation(match)]) === null || _b === void 0 ? void 0 : _b.value;
        if (!key || !value) {
            translations.push(item);
            return;
        }
        const concatenatedValue = item.replace(/t\((.*?)\)/g, function ($1) {
            var _a;
            return (_a = TranslationService.get()[prepareTranslation($1)]) === null || _a === void 0 ? void 0 : _a.value;
        });
        if (isLoggedIn() && !asString) {
            // Add raw elements to a seperate array because the replace function already concatenates to string.
            const concatenatedValue = item.replace(/t\((.*?)\)/g, function ($1) {
                var _a;
                return (_a = TranslationService.get()[prepareTranslation($1)]) === null || _a === void 0 ? void 0 : _a.value;
            });
            translations.push(renderTranslateLabelsHtml(concatenatedValue, key));
        }
        else {
            translations.push(concatenatedValue ? concatenatedValue : match);
        }
        // Only statisfies the replace function which requires strings.
        return match;
    });
    return translations;
};
const isLoggedIn = () => {
    return !!document.querySelectorAll('.typo3-adminPanel-active').length;
};
const renderTranslateLabelsHtml = (translation, key) => {
    var _a, _b;
    const tooltipRef = useRef();
    const tooltipWrapperRef = useRef();
    const actualKey = (_b = (_a = TranslationService.get()[prepareTranslation(key)]) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : key;
    useEffect(() => {
        var _a, _b;
        const click = () => {
            const translateLabelModule = document.querySelector('[data-typo3-tab-id="translatelabel_translatelabel"]');
            const translateLabelInfoModule = document.querySelector('[data-typo3-tab-id="translatelabel_translatelabel_info"]');
            document.querySelector('[data-identifier="actions-document-localize"]').click();
            const lines = Array.from(translateLabelModule.querySelectorAll('[data-translatelabels-key]')).concat(Array.from(translateLabelInfoModule.querySelectorAll('[data-translatelabels-key]')));
            lines.forEach(function (elem) {
                elem.classList.remove('translatelabels-highlight');
            });
            const tableRow = translateLabelModule.querySelectorAll('[data-translatelabels-key="' + actualKey + '"]')[0];
            tableRow.classList.add('translatelabels-highlight');
            const tableRowInfoModule = translateLabelInfoModule.querySelectorAll('[data-translatelabels-key="' + actualKey + '"]')[0];
            tableRowInfoModule.classList.add('translatelabels-highlight');
            const editField = tableRow.getElementsByClassName('editable')[0];
            setFocusIntoEditable(editField);
        };
        //@ts-ignore
        (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.style.display = 'block';
        //@ts-ignore
        const instance = window.tippy(tooltipWrapperRef.current, {
            arrow: true,
            interactive: true,
            allowHTML: true,
            followCursor: true,
            content: tooltipRef.current,
            maxWidth: 500,
        });
        (_b = tooltipRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('click', click);
        return () => {
            var _a;
            //@ts-ignore
            instance.destroy();
            (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', click);
        };
    }, [actualKey]);
    return (React.createElement(React.Fragment, { key: key },
        React.createElement("span", { className: "translatelabels-tooltip", ref: tooltipWrapperRef },
            React.createElement("span", { className: "translatelabels-translation", "data-translatelabels-role": "translation" }, translation),
            React.createElement("span", { style: { display: 'none' }, ref: tooltipRef, className: "translatelabels-tooltip-inner" },
                React.createElement("span", null,
                    "Verander het label: \"",
                    translation,
                    "\" ...")))));
};
function setFocusIntoEditable(editField) {
    // focus after last char of editable field
    const s = window.getSelection(), r = document.createRange();
    r.setStart(editField.firstChild, 0);
    r.setEnd(editField.lastChild, editField.lastChild.length);
    s.removeAllRanges();
    s.addRange(r);
    editField.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
}
/**
 * A backend translation is a string which is sent from the backoffice encapsulated by 't(' as prefix and ')' as suffix.
 * Supports multiple subjects per string. The subject can be everywhere in a string.
 * Supported:
 * - 'Oempa t(translation1)'
 * - 't(translation1)'
 * - 't(apmeo) t(apmeo) t(apmeo)'
 * - '1 t(apmeo)'
 */
const hasTranslationTags = (item) => {
    return /t\((.*?)\)/.test(item);
};
// Check if t(<text>) is present in the item (used for php translations).
// Remove t( and ) to translate properly.
const prepareTranslation = (item) => {
    return item.replace(/t\((.*?)\)/, function ($1, $2) {
        return $2;
    });
};
export default Translation;
